module.exports = __webpack_public_path__ + "img/Kiln-Calendar-Graphic.1dd8462d.gif";